import { Message, MessageBox } from 'element-ui'
import util from '@/libs/util.js'
import router from '@/router'
import { login, userInfo, Logout, refreshToken } from '@api/sys.login'
import { getDynamicMenu } from '@api/menu'
import { querySmsServiceStatus } from '@api/message'
import { getMatchDropdown, recordMatchVisit } from '@/api/match'
import { Gtoken } from '@/config/index.js'
export default {
  namespaced: true,
  state: {
    userState: {}
  },
  mutations: {
    SET_USERSTATE: (state, userState) => {
      state.userState = userState
    }

  },
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login(
      { commit, dispatch },
      {
        portalType = '', // 1：平台级登录入口 2：运营级登录入口
        loginType = '', // 管理后台登录方式 1：手机号+登录验证码 2：手机号+短信验证码 3：admin+登录密码
        mobile = '', // 账号手机号
        username = '', // 用户名  只在admin登录时使用
        password = '', // 密码 loginType=1时必传
        smsCode = '', // 验证码四位随机数：loginType=2时必传
        uuid = '', // uuid
        captcha = '' // 图形验证码
      } = {}
    ) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        login({
          mobile,
          loginType,
          portalType,
          username,
          password,
          smsCode,
          uuid,
          captcha
        })
          .then(async res => {
            commit('SET_USERSTATE', res)


            if(parseInt(res.data)> 2){
              return resolve(res)
            }
            if (res.code === '0') {
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天

              util.cookies.set('token', res.data.token)
              const token = util.cookies.get('token')

              util.cookies.set('refreshToken', res.data.refresh_token)

              const exDate = new Date(Date.parse(new Date()) + res.expire * 1000)
              console.log('login-token', token)
              console.log('Gtoken', Gtoken)
              Gtoken.aaa = res.data.token
              console.log('Gtoken2', Gtoken)
              util.cookies.set('expireTime', exDate)

              // await dispatch('refreshToken', {})
              sessionStorage.loginStatus = '1'
              userInfo({})
                .then(async r => {
                  console.log(typeof r, r)
                  console.log('typeof r, r')
                  util.cookies.set('uuid', 'userId' + r.user.userId)
                  // 用户刚登录时赛事列表初始状态值为"1"，切换赛事后状态值为"0"
                  localStorage.setItem("d2admin-operate-matchListStatus", "1")
                  // 用户刚登录时拍卖列表初始状态值为"1"，切换拍卖后状态值为"0"
                  localStorage.setItem("d2admin-operate-auctionListStatus", "1")
                  await dispatch(
                    'd2admin/user/set',
                    {
                      user: r.user,
                      shed: r.shed,
                      permissions: r.permissions,
                      roleId: r.roleId
                    },
                    { root: true }
                  )
                  // 用户登录后从持久化数据加载一系列的设置
                  await dispatch('load')
                  // 清除tabs(登录后不显示多页列表，但是只注释掉load方法中的openedLoad方法的话，效果不满足要求，以后时间充裕再改)
                  await dispatch('d2admin/page/closeAll', {}, { root: true })
                  
                  // 结束
                  resolve()
                })
                .catch(err => {
                  // 结束
                  resolve()
                  console.log(err)
                })
                
              // // 获取动态菜单  原来的
              // getDynamicMenu({})
              //   .then(async res => {
              //     await commit('d2admin/menu/menuListSet', res.menuList, { root: true })
              //     resolve()
              //   })
              //   .catch(err => {
              //     resolve()
              //     console.log(err)
              //   })
              // 获取动态菜单 从平台端cope过来的
              getDynamicMenu({})
                .then(async res => {
                  // console.log('getDynamicMenugetDynamicMenugetDynamicMenu')
                  // console.log('获取权限接口',res.notAvailablePermissions)
                  localStorage.setItem("d2admin-admin-notAvailablePermissions", JSON.stringify(res.notAvailablePermissions))
                  // console.log('当前路径',this.$route.fullPath)
                  // console.log('当前路由',this.$route)
                  await commit('d2admin/menu/menuListSet', res.menuList, { root: true })
                  if(res.notAvailablePermissions.includes(this.$route.fullPath)){
                    router.push('/noPermission')
                  }
                  // 登录后初始化侧边栏
                  let asideList = JSON.parse(localStorage.getItem("d2admin-asideList")) || []
                  let matched = router.app['_route'].matched
                  const _side = matched[0].path == '' ? asideList.filter(menu => menu.path === matched[1].path) : asideList.filter(menu => menu.path === matched[0].path)
                  await commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [], { root: true })
                  // 登录后初始化侧边栏后跳转到侧边栏第一项的页面
                  if (_side.length > 0) {
                    // 如果第一项还有二级菜单，就跳到二级菜单的第一项
                    if (_side[0].children[0].children && _side[0].children[0].children.length > 0) {
                      router.push({
                        path: _side[0].children[0].children[0].path
                      })
                    } else {
                      router.push({
                        path: _side[0].children[0].path
                      })
                    }
                  }
                  resolve()
                })
                .catch(err => {
                  resolve()
                  console.log(err)
                })

              // 查询用户是否开通了短信服务
              console.log('短信')
              querySmsServiceStatus({})
                .then(async res => {
                  await dispatch('d2admin/user/setSmsServiceStatus', res.data.isOpen, { root: true })
                  resolve()
                })
                .catch(err => {
                  resolve()
                  console.log(err)
                })

              // 查询赛事
              console.log('赛事')
              getMatchDropdown({})
                .then(async matchRes => {
                  console.log('matchRes', matchRes)
                  if (parseInt(matchRes && matchRes.code) == 0) {
                    console.log('matchRes.data.matchList', matchRes.data.matchList)



                    let curMatchId, curMatchName
                    if (matchRes.data.recordMatch && matchRes.data.recordMatch.id || matchRes.data.recordMatch && matchRes.data.recordMatch.id != '0') {
                      console.log('1')
                      curMatchId = matchRes.data.recordMatch.id
                      curMatchName = matchRes.data.recordMatch.name
                    } else if (matchRes.data.matchList.length) {
                      console.log('2')
                      curMatchId = matchRes.data.matchList[0].id
                      curMatchName = matchRes.data.matchList[0].name
                      recordMatchVisit(matchRes.data.matchList[0].id)

                    } else if (matchRes.data.matchList.length == 0) {
                      console.log('3')
                      console.log('没有赛事列表')
                      router.push({
                        path: '/matchlist/match/index'
                      })
                      return
                    }

                    setTimeout(() => {
                      resolve()
                    }, 2000)


                    // if (matchRes.data.matchList.length == 0) {
                    //   console.log('4')
                    //   console.log('没有赛事列表')
                    //   router.push({
                    //     path: '/matchlist/match/index'
                    //   })
                    //   this.closePage({ path: '/index' })
                    //   return
                    // } else {
                    //   console.log('5')
                    //   setTimeout(() => {
                    //     resolve()
                    //   }, 2000)
                    // }



                    await dispatch('d2admin/user/setMatchStatus', {
                      matchId: curMatchId,
                      matchName: curMatchName,
                    }, { root: true })


                  }


                })
                .catch(err => {
                  router.push({
                    path: '/matchlist/match/index'
                  })
                  // resolve()
                  console.log(err)
                })
                
            } else if(res.code !== '500'&&res.code !== '4001'&&res.code !== '401'){ 
              
            
              Message.error(res.msg)
            }
            // resolve()
            // return res
          })
          .catch(err => {
            // alert(1)
            console.log('err: ', err)
            reject(err)
          })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      async function logout() {
        // 接口
        // Logout({}).then(async res => {
        //   console.log('登出')
        //   // 删除cookie
        //   util.cookies.remove('token')
        //   util.cookies.remove('uuid')
        //   // 清空 vuex 用户信息
        //   await dispatch('d2admin/user/set', {}, { root: true })
        //   // 跳转路由
        //   router.push({
        //     name: 'login'
        //   })
        // })
        await Logout()
        //   // 删除cookie
        util.cookies.remove('token')
        util.cookies.remove('refreshToken')
        util.cookies.remove('expireTime')
        util.cookies.remove('uuid')
        localStorage.removeItem('member_match_id')
        localStorage.removeItem('match_match_id')
        localStorage.removeItem('d2admin-asideList')
        localStorage.removeItem("d2admin-operate-matchListStatus") // 移除赛事列表状态值
        localStorage.removeItem("d2admin-operate-auctionListStatus") // 移除拍卖列表状态值
        // 清空 vuex 用户信息
        await dispatch('d2admin/user/set', {}, { root: true })
        // 清空 vuex 用户是否开通短信服务
        await dispatch('d2admin/user/setSmsServiceStatus', undefined, { root: true })
        // 跳转路由
        router.push({
          name: 'login'
        })
        // 在路由跳转后清除，不然有bug
        sessionStorage.removeItem("smsCustomContent") // 移除自定义短信缓存的值
      }
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true })
        MessageBox.confirm(
          '注销当前账户吗?  打开的标签页和用户设置不会被保存。',
          '确认操作',
          {
            confirmButtonText: '确定注销',
            cancelButtonText: '放弃',
            type: 'warning'
          }
        )
          .then(() => {
            commit('d2admin/gray/set', false, { root: true })
            sessionStorage.loginStatus = '0'
            logout()
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true })
            Message({
              message: '放弃注销用户'
            })
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load({ dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        // await dispatch('d2admin/page/openedLoad', null, { root: true }) // 产品说去掉
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // end
        resolve()
      })
    },
    async refreshToken({ state }) {
      if (state.userState.code == '5001' || state.userState.code == '5002' || state.userState.code == '5003') {
        return;
      }
      console.log('util.cookies.get.refreshToken', util.cookies.get('refreshToken'))
      const res = await refreshToken({ refreshToken: util.cookies.get('refreshToken') })
      if (res && res.code === '0') {
        util.cookies.remove('token')
        util.cookies.set('token', res.token)
        util.cookies.remove('refreshToken')
        util.cookies.remove('expireTime')

        util.cookies.set('refreshToken', res.refresh_token)
        const exDate = new Date(Date.parse(new Date()) + res.expire * 1000)
        util.cookies.set('expireTime', exDate)
      }
    }
  }
}
